import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { AddCandidatesPageComponent } from './add-candidates-page.component';
import { AddCandidatesModule } from './add-candidates/add-candidates.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.addCandidates',
    url: '/addCandidates',
    component: AddCandidatesPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      jobId: null
    }
  }
];

@NgModule({
  declarations: [AddCandidatesPageComponent],
  imports: [
    CommonModule,
    AddCandidatesModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [AddCandidatesPageComponent],
  exports: [AddCandidatesPageComponent]
})
export class AddCandidatesPageModule { }
